module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAABHNCSVQICAgIfAhkiAAAAMRJREFUOE/tVcENwjAQsyeCDaCTwAbAJMAGZQM2gG7QjYxcFSTSJilI6auW+urFse58DiU9AWyQxpXk0SWSLgAOmfo7JSlT5N8NyW1PPEUIPsQkGV4gyWSPCHFF0pd84S10IfZwu5mVbwWAbuoB1gBsrzFX2H7tyJluoEXtZkVWlkJNsu59vAfgL4V24N0JyzKppBxxv/urjIxb0IpdthXFswJAFbHbOWK3U8RuzpYZFmRJt1lCKGXNv54mJ1RuQX59TJsXbysWaIWaL28AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/grid.png
// module id = 1211
// module chunks = 0